app.controller("AddUserController", ["$scope", "$uibModalInstance", "Users", "StaticData", "toastr",
    function ($scope, $uibModalInstance, Users, StaticData, toastr) {
        $scope.format = "dd-MM-yyyy";
        $scope.popup1 = {
            opened: false
        };
        $scope.dateOptions = {
            "is-open": "false",
            dateDisabled: false,
            formatYear: 'yyyy',
            maxDate: new Date(),
            startingDay: 1
        };
        $scope.user = {
            email: "",
            personalNo: "",
            documentNo: "",
            firstName: "",
            lastName: "",
            birthDate: null,
            birthPlace: "",
            gender: "",
            password: "",
            userConfig: {},
            image: "",
            nationality: "",
            citizenship: "",
            phone: "",
            physicalAddress: "",
            legalAddress: ""
        };

        StaticData.getItemsByKey("gender").then(function (gender) {
            $scope.genders = [{name: "სქესი"}].concat(gender);
            $scope.genderMap = _.keyBy($scope.genders, '_id');
        });

        StaticData.getItemsByKey("citizens").then(function (citizens) {
            $scope.citizenships = citizens;
        });

        $scope.open1 = function () {
            $scope.popup1.opened = true;
        };

        $scope.create = function () {
            $scope.user.gender = $scope.gender;

            if(!$scope.user.email){
                toastr.error('', 'გთხოვთ მიუთითოთ ელ.ფოსტა');
            } else if(!$scope.user.password){
                toastr.error('', 'გთხოვთ მიუთითოთ პაროლი');
            } else if(!$scope.user.firstName){
                toastr.error('', 'გთხოვთ მიუთითოთ სახელი');
            } else if(!$scope.user.lastName){
                toastr.error('', 'გთხოვთ მიუთითოთ გვარი');
            } else if(!$scope.user.personalNo){
                toastr.error('', 'გთხოვთ მიუთითოთ პირადი ნომერი');
            } else if(!$scope.user.citizenship){
                toastr.error('', 'გთხოვთ მიუთითოთ მოქალაქეობა');
            } else if($scope.user.citizenship === 'georgian' && ($scope.user.personalNo.length !== 11 || isNaN($scope.user.personalNo) === true)){
                    toastr.error('', 'გთხოვთ მიუთითოთ პირადი ნომერი');
            } else if(!$scope.user.birthDate){
                toastr.error('', 'გთხოვთ მიუთითოთ დაბადების თარიღი');
            } else if(!$scope.user.gender){
                toastr.error('', 'გთხოვთ მიუთითოთ სქესი');
            } else if(!$scope.user.citizenship){
                toastr.error('', 'გთხოვთ მიუთითოთ მოქალაქეობა');
            } else if(!$scope.user.phone){
                toastr.error('', 'გთხოვთ მიუთითოთ ტელეფონის ნომერი');
            } else {
                Users.create($scope.user).then(function (resp) {
                    toastr.success('', 'მომხმარებელი დამატებულია');
                    $uibModalInstance.close();
                }).catch(function (err) {
                    if(err) {
                        if(err&&err.data === 'INVALID_EMAIL_FORMAT') {
                            toastr.error('', 'მეილის ფორმატი არასწორია.');
                        }
                        if(err&&err.data === 'Email Already Exists') {
                            toastr.error('', 'მომხმარებელი ასეთი ელ.ფოსტით უკვე არსებობს.');
                        }
                        if(err&&err.data === 'User Already Exists') {
                            toastr.error('', 'მომხმარებელი ასეთი პირადი ნომრით.');
                        }
                    }
                });
                return;
            }
        };
        $scope.close = function () {
            $uibModalInstance.dismiss();
        };
    }
]);

